var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',[_vm._v(" 〒852-8521 日本長崎県長崎市文教町1-14\n    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-row',[_vm._v("\n      Copyright（C）2025    \n      The Society for Experimental Linguistics\n    ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20c757a9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footerComponent.vue
// module id = null
// module chunks = 